import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../actions/authActions';

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await dispatch(requestPasswordReset(email));
    setBusy(false);
    setDone(true);
  };

  return (
    <section className="section narrow">
      <h1>Forgot your password?</h1>
      {done ? (
        <>
          <p className="status success">If that email is in our system, a reset link is on its way. Check your inbox in a minute.</p>
          <p className="muted"><Link to="/login">Back to sign in</Link></p>
        </>
      ) : (
        <form className="auth-form" onSubmit={submit}>
          <label>Email<input required type="email" value={email} onChange={e => setEmail(e.target.value)} /></label>
          <button className="btn-primary" type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button>
          <p className="muted" style={{marginTop:'1rem'}}><Link to="/login">Back to sign in</Link></p>
        </form>
      )}
    </section>
  );
}
